var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadshotTipsAngle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "195px",
    height: "145px",
    viewBox: "0 0 195 145",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4A9154A1-1DA0-4248-8D38-323171CAAEB7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Headshot-step-two-Copy",
    transform: "translate(-620.000000, -330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(622.500000, 330.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(36.949580, 0.000000)",
    fill: "#303843"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6797983,99.1722017 L95.6778235,99.2160672 L95.6205546,101.216824 C95.4755546,106.217496 94.2095462,111.154807 91.9334118,115.802118 C91.9334118,115.802118 89.351437,120.875899 87.9976975,122.412412 C87.3567731,123.294597 86.9071513,123.803924 86.1005126,124.611782 C86.059084,124.651992 86.0237479,124.682454 85.9835378,124.722664 C84.8259748,126.064218 83.5806807,127.366782 82.2305966,128.60842 C74.5017311,135.719513 64.6685378,139.965941 55.9271092,139.965941 C47.1856807,139.965941 37.3524874,135.719513 29.6236218,128.60842 C28.0456807,127.155983 21.8984118,120.475017 20.7079496,118.228126 C18.2027395,113.500395 16.4566471,108.426613 16.3384538,103.066487 C16.2872773,102.451151 16.2507227,101.834597 16.2336639,101.216824 L16.1751765,99.2160672 L14.1744202,99.1722017 C11.8373613,99.1222437 4.21084874,98.078 4.21084874,86.7411933 C4.21084874,79.0086723 5.71811765,74.7001008 13.4153025,74.3406471 C14.3328235,75.6017815 16.8563109,71.9548487 16.2677815,71.1043445 C16.2775294,68.9464034 16.2848403,68.5101849 16.2872773,68.4443866 C17.0256807,55.7818655 19.8111429,39.2737983 25.2285378,34.4217815 C27.9153025,32.0164874 31.398958,31.2878319 35.4333697,31.2878319 C38.3455546,31.2878319 41.546521,31.668 44.9400084,32.0713193 C48.5247983,32.4953529 52.231437,32.9364454 55.9271092,32.9364454 C59.5155546,32.9364454 63.1649244,32.3491345 66.6961008,31.7813193 C73.0553866,30.7590084 79.0637479,29.7939664 83.1298403,32.5696807 C86.6122773,34.9457311 89.6792101,40.2522437 91.9967731,47.9140924 C93.8634958,54.0784202 95.1648403,61.5611513 95.5657227,68.4200168 C95.5693782,68.5028739 95.5766891,68.9403109 95.586437,71.0568235 C95.2135798,71.4772017 97.5360168,75.1716555 98.3036639,74.3260252 C104.361983,74.5319496 107.644588,76.7337563 107.644588,86.7411933 C107.644588,98.078 100.016857,99.1222437 97.6797983,99.1722017 M105.920429,72.0218655 C106.727067,67.2868235 108.909378,52.9135462 108.028412,40.6299748 C107.482529,33.0119916 105.50858,23.210479 99.211437,19.780437 C96.3808908,18.2378319 93.1287479,18.2061513 89.5220252,19.6768655 C85.7032857,11.1742605 77.4663109,4.27884034 67.938958,1.7882521 C58.2324874,-0.748638655 48.2811008,-0.0443529412 38.6574874,0.639218487 L17.2766891,2.15379832 C13.0582857,2.45232773 8.32446218,3.07741176 5.54509244,6.72556303 C3.54555462,9.3477479 3.08252941,13.1274958 4.30589076,16.8341345 C5.15883193,19.4136723 6.66610084,21.6556891 8.14047059,23.6601008 C-0.694781513,40.2193445 4.2632437,65.3311513 5.83509244,72.073042 C0.857571429,75.0473697 -0.000243697479,80.9424118 -0.000243697479,86.7411933 C-0.000243697479,95.8871597 4.69336975,102.151403 12.1261429,103.222454 C13.949,126.432202 36.714,144.177034 55.9271092,144.177034 C75.1402185,144.177034 97.9052185,126.432202 99.7280756,103.222454 C107.15963,102.151403 111.854462,95.8871597 111.854462,86.7411933 C111.854462,80.9070756 110.982025,74.977916 105.920429,72.0218655",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 84.500000)",
    stroke: "#7A838E",
    strokeLinecap: "round",
    strokeWidth: 4.40971685
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.440971685,
    y1: 0.440971685,
    x2: 11.9062355,
    y2: 0.440971685,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.0089742,
    y1: 0.440971685,
    x2: 55.474238,
    y2: 0.440971685,
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.2249729,
    y1: 0.440971685,
    x2: 33.6902367,
    y2: 0.440971685,
    id: "Line-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.7929754,
    y1: 0.440971685,
    x2: 77.2582392,
    y2: 0.440971685,
    id: "Line-Copy-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.5769766,
    y1: 0.440971685,
    x2: 99.0422404,
    y2: 0.440971685,
    id: "Line-Copy-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.360978,
    y1: 0.440971685,
    x2: 120.826242,
    y2: 0.440971685,
    id: "Line-Copy-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(133.879004, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.440971685,
    y1: 0.440971685,
    x2: 11.9062355,
    y2: 0.440971685,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.0089742,
    y1: 0.440971685,
    x2: 55.474238,
    y2: 0.440971685,
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.2249729,
    y1: 0.440971685,
    x2: 33.6902367,
    y2: 0.440971685,
    id: "Line-Copy-2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadshotTipsAngle);
export default __webpack_public_path__ + "static/media/headshot-tips-angle.762b848e2f73e5d91a8d601e474c34fc.svg";
export { ForwardRef as ReactComponent };